import { useTheme } from "app/shared";
import { FC } from "react";
import { IData } from "../IdoInfoComponent/IdoInfoComponent";
import styles from "./CeoMessage.module.scss";

interface ICeoMessage {
  ceoData: IData[];
  ceoPhoto: IData[];
}

const CeoMessage: FC<ICeoMessage> = ({ ceoData, ceoPhoto }) => {
  const { theme } = useTheme();

  const ceoPhotoUrl = ceoPhoto.length > 0 ? ceoPhoto[0].value : "";

  return (
    <div
      className={`${styles.widget} ${theme === "dark" ? styles.darkTheme : ""}`}
    >
      <div className={styles.content}>
        {ceoPhotoUrl && (
          <img src={ceoPhotoUrl} alt="CEO Photo" className={styles.logo} />
        )}
        <div className={styles.wrapper}>
          {ceoData.map((item, index) => (
            <div key={index} className={styles.item}>
              <span className={styles.label}>{item.label}:</span>
              <span className={styles.value}>{item.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CeoMessage;
